/**
 * Syncs privacy level from the current user's default content audience preference.
 */
import React, { useEffect, useState } from "react";
import { useUser } from "util/UserContext";
import { PrivacyLevel } from "util/userUtils";

export interface UsePrivacyDefaultsResult {
  privacy: PrivacyLevel;
  setPrivacy: React.Dispatch<React.SetStateAction<PrivacyLevel>>;
}

/**
 * Initializes privacy from `currentUser.properties.privacy_content_default_audience`
 * and updates when the user loads or preference changes.
 */
export function usePrivacyDefaults(): UsePrivacyDefaultsResult {
  const { currentUser, awaitingUser } = useUser();
  const [privacy, setPrivacy] = useState<PrivacyLevel>(
    (currentUser?.properties?.privacy_content_default_audience?.value as PrivacyLevel | undefined) ??
      "public"
  );

  useEffect(() => {
    if (awaitingUser) return;
    const pref = currentUser?.properties?.privacy_content_default_audience?.value as
      | PrivacyLevel
      | undefined;
    setPrivacy(pref ?? "public");
  }, [currentUser, awaitingUser]);

  return { privacy, setPrivacy };
}
